import React from "react";
import { useSelector } from "react-redux";

import Boards from "../../components/Filters/Boards";
import SelectDatePicker from "../../components/Filters/SelectDatePicker";
import Epics from "../../components/Filters/Epics";
import Team from "../../components/Filters/Team";
import ToggleInput from "../../../../components/ToggleInput";
import GlobalSearch from "../../../../components/Search";
import { useWorklogFiltersState } from "../../hooks/useWorklogFiltersState";

function Filters() {
  const checkedList = useSelector((state) => state.search.boardSearch);
  const {
    groupingUsers,
    handleChange,
    handleVisibilityChange,
    inputValue,
    isVisible,
    teams,
  } = useWorklogFiltersState();

  return (
    <div className="worklog-filter d-flex justify-content-space-between align-items-center mt-4">
      <div
        className="d-flex align-items-center"
        style={{ position: "relative" }}>
        <ToggleInput value={isVisible} setValue={handleVisibilityChange} />
        <div className={`slide-panel d-flex ${isVisible ? "open" : ""}`}>
          <Team user={groupingUsers} team={teams} />
          <Boards />
          {checkedList && checkedList.length === 1 && <Epics />}
          <div className={checkedList && checkedList.length === 1 ? "" : "ml-4"}>
            <GlobalSearch
              placeholder={"Search..."}
              searchText={inputValue}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div>
        <SelectDatePicker />
      </div>
    </div>
  );
}

export default Filters;
